function kalviyo(email) {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const raw = JSON.stringify({
    "email": email
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  };

  fetch("https://klaviyo-api-gray.vercel.app/klaviyo", requestOptions)
    .then((response) => response.text())
    .then((result) => {
      console.log('')
    })
    .catch((error) => console.error(error));
}